import { BASE_COMMENT_FRAGMENT } from '../fragments/baseComment';

export const REPLY_MUTATION = `
  mutation ReplyMutation(
    $content: String!
    $offerId: ID!
    $parentId: ID!
    $replyTo: ID
    $followOffer: Boolean
  ) {
    me {
      replyAsComment(
        content: $content
        offerId: $offerId
        parentId: $parentId
        replyTo: $replyTo
        followOffer: $followOffer
      ) {
        ...BaseCommentFragment

        replyTo {
          ...BaseCommentFragment
        }
      }
    }
  }

  ${BASE_COMMENT_FRAGMENT}
`;
